import request from '@/utils/request'

// 查询月度计划列表
export function ApiSopMonthPlanList (query) {
  return request({
    url: '/scp/sopMonthPlan/list',
    method: 'get',
    params: query
  })
}

// 查询月度计划列表
export function ApiUpdateSopMonthPlan (query) {
  return request({
    url: '/scp/sopMonthPlan',
    method: 'put',
    data: query
  })
}
// 查询月度计划列表
export function ApiDeleteSopMonthPlan (query) {
  return request({
    url: '/scp/sopMonthPlan',
    method: 'delete',
    params: query
  })
}
// 发布月度计划
export function ApiSendSopMonthPlan (query) {
  return request({
    url: '/scp/sopMonthPlan/publishPlan',
    method: 'get',
    params: query
  })
}
// 启动计算
export function ApiStartCalculate (query) {
  return request({
    url: '/scp/sopMonthPlan/startCalculate',
    method: 'get',
    params: query
  })
}

// 停止计算
export function ApiStopCalculate (query) {
  return request({
    url: '/scp/sopMonthPlan/stopCalculate',
    method: 'get',
    params: query
  })
}

// /sopMonthPlan
export function ApiNewMonthPlan (query) {
  return request({
    url: '/scp/sopMonthPlan',
    method: 'post',
    data: query
  })
}
// 确认并启动
export function ApiSaveAndCalculate (query) {
  return request({
    url: '/scp/sopMonthPlan/saveAndCalculate',
    method: 'post',
    data: query
  })
}
// 查询月度计划明细
export function ApiSopMpProductionDemand (query) {
  return request({
    url: '/scp/sopMpProductionDemand/list',
    method: 'get',
    params: query
  })
}
// 月度计划-产能负荷
// 查询月度计划明细
export function ApiSopMpCapacityLoadPeriod (query) {
  return request({
    url: '/scp/sopMpCapacityLoad/periodList',
    method: 'get',
    params: query
  })
}
export function ApiSopMpCapacityTypeList (query) {
  return request({
    url: '/scp/sopMpCapacityLoad/typeList',
    method: 'get',
    params: query
  })
}
// 查询月度计划明细
export function ApiSopMpProductionDemandDetail (query) {
  return request({
    url: '/scp/sopMonthPlan/examineProduction',
    method: 'get',
    params: query
  })
}
// 发布月度计划
export function ApipoReqLinesAll (query) {
  return request({
    url: '/po/porReqLinesAll/publishPlan',
    method: 'get',
    params: query
  })
}

// 关闭月度计划
export function ApiMonthPlanClose (query) {
  return request({
    url: '/scp/sopMonthPlan/monthPlanClose',
    method: 'post',
    params: query
  })
}
